import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import ExportDataTableButton from "../../components/ExportDataTableButton";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar,
} from "../../../_metronic/_partials/controls";
import { Formik } from "formik";
import { Col, } from "react-bootstrap";
import GamerjiTournamentSummeryDetailsNew from "./GamerjiTournamentSummeryDetailsNew";
import moment from "moment-timezone";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import "./tournament.css";
import * as UIHelpers from "../../components/UIHelpers";
import DropdownReactSelect from "../../components/DropdownReactSelect";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { imageUrl } from "../../components/UIHelpers";
const GamerjiTournamentView = (props) => {
  const { id } = useParams();
  let history = useHistory();
  const suhbeader = useSubheader();
  const dispatch = useDispatch();
  // const [isContainerVisible, setIsContainerVisible] = useState(false);
  // const [isDeleteShow, setIsDeleteShow] = useState(false);
  // const [deleteItemRow, setDeleteItemRow] = useState(undefined);
  const [roundsData, setRoundData] = useState([]);
  const [selectDateRange, setSelectDateRange] = useState(null);
  const [constestData, setcontestData] = useState([]);
  const [dateRange, setDateRange] = useState({
    from: moment(new Date().setHours(0, 0, 0, 0)),
    to: moment(new Date().setHours(23, 59, 59, 999)),
  });
  const [timeSlotForDropdown, setTimeSlotForDropdown] = useState([
    { value: "all", label: "All" },
    { value: "timeSlot1", label: "6AM-9AM" },
    { value: "timeSlot2", label: "9AM-12PM" },
    { value: "timeSlot3", label: "12PM-3PM" },
    { value: "timeSlot4", label: "3PM-6PM" },
    { value: "timeSlot5", label: "6PM-9PM" },
    { value: "timeSlot6", label: "9PM-12AM" },
  ]);
  // const [timeSlotForSelectedDropdown, setTimeSlotForSelectedDropdown] = useState(null);
  // ['waiting','started','review','cancelled','completed']
  const [statusForDropdown, setStatusForDropdown] = useState([
    { value: "all", label: "All" },
    { value: "waiting", label: "Waiting" },
    { value: "started", label: "Started" },
    { value: "review", label: "Review" },
    { value: "completed", label: "Completed" }
  ]);
  // const [statusForSelectedDropdown, setStatusForSelectedDropdown] = useState(null);
  // const [assignForDropdown, setAssignForDropdown] = useState([]);
  // const [assignForSelectedDropdown, setAssignForSelectedDropdown] = useState(null);
  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );

  const {
    actionsLoading,
    exportData,
    // totalCount,
    // contestUsers,
    // listLoading,
    tournamentForEdit,
    // tournamentRules,
    // bracketsImages,
    // tournamentPointPool,
    // tournamentPrizePool,
    pointSummaryActionsLoading,
    tournamentRounds,
    staffUserList
  } = currentState;

  useEffect(() => {
    dispatch(actions.fetchSingleTournament(id, false));
    dispatch(actions.fetchTournamentRounds(id));
    dispatch(actions.fetchStaffUsers(id));
    // dispatch(actions.fetchTournamentRules(id));
    // dispatch(actions.fetchTournamentPointPool(id));
    // dispatch(actions.fetchTournamentPrizePool(id));
  }, [id, dispatch]);

  // {console.log("tournafdfdfdsfdfmentId", fetchSingleTournament(id))}

  const backToList = () => {
    history.push(`/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/list`);
  };

  const CurrencyIcoon = ({ item }) => {
    return (
      <span className="text-dark-50 font-weight-bold">
        {item.currency && item.currency.img ? (
          <img
            className="currency"
            // src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${item.currency &&
            //   item.currency.img.default}`}
              src={imageUrl(item.currency && item.currency.img.default)}
            alt="currency"
          />
        ) : (
          <span className="text-dark-50 font-weight-bold">₹</span>
        )}
      </span>
    );
  };

  useEffect(() => {
    // setTitle(_title); 
    suhbeader.setTitle("Tournament Info");
  }, [id]);

  const exportPointButtonCSVAPICall = () => {
    // console.log("Dispatching action with payload:", { export: true });
    dispatch(actions.fetchGamerjiPointSummaryexport(id, { export: true })).then((success) =>
      success ? window.location.reload() : null
    );;
  };
  const downloadPointSummary = () => {
    window.open(tournamentForEdit?.summaryLink, "_blank");
  }

  const exportButtonCSVAPICalll = () => {
    // console.log("Dispatching action with payload:", { export: true });
    dispatch(actions.fetchGamerjiRankSummaryexport(id, { export: true }));
  };
  useEffect(() => {
    // console.log("exportData: ", exportData);
    if (
      exportData &&
      exportData?.success &&
      exportData?.item &&
      exportData?.item?.fileName
    ) {
      window.open(
        `${UIHelpers.exportUrl}${exportData?.item?.fileName}`,
        "_blank"
      );
    }
  }, [exportData]);
  // const viewPointSummary1 = () => {
  //   console.log("Dispatching action with payload:", { export: true });
  //   dispatch(actions.fetchGamerjiPointSummaryexport(id, { export: true }));
  // };

  // useEffect(() => {
  //   // Initial fetch when component mounts
  //   dispatch(actions.fetchGamerjiPointSummary(id));
  // }, [id, dispatch]);

  useEffect(() => {
    if(tournamentForEdit){
    const start = new Date(tournamentForEdit.startDate);
    const end = new Date(tournamentForEdit.endDate);
    // end.setDate(end.getDate() + 1);
    // start.setDate(start.getDate() - 1);
    const dates = [];
    while (start <= end) {
      dates.push(new Date(start.toISOString().split('T')[0])); // Format date as 'YYYY-MM-DD'
      start.setDate(start.getDate() + 1); // Move to the next day
    }
    setSelectDateRange(dates)
  }
  }, [tournamentForEdit]);

  const viewRankSummary = () => {
    const url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/gamerji/rankSummary/${id}`;
    window.open(url, "_blank");
  };
  const viewPointSummary = () => {
    const url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/gamerji/pointSummary/${id}`;
    window.open(url, "_blank");
  };

  const renderHeader = (subMatch) => {
    return (
      <thead>
        <tr>
          <th>Title</th>
          <th>Date</th>
          <th>Time</th>
          <th>RP TIME </th>
          <th>SS TIME </th>
          <th>Status</th>
          {!subMatch && <th>Total User Count</th>}
          {!subMatch && <th>Total Winners Count</th>}
          <th>Map</th>
          <th>Perspective</th>
          <th>Action</th>
        </tr>
      </thead>
    );
  };

  const ContestStatus = (data) => {
    let status = "Waiting";
    let winnerCount = 0;
    let userCount = 0;
    let joinedCount = 0;
    let totalActualWinners = 0;
    let updateRPTime = "Not Updated";
    let updateSSUploadTime = "Not Updated";
    let updateWinningsTime = "Not Updated";
    let assignUser = "Not Updated";
    let matchDate = "-";
    let matchTime = "-";
    // console.log("ContestStatus",data,constestData)
    if (constestData?.length > 0) {
      constestData.forEach((contest) => {
        if (contest.code === data.matchId && !contest.isDeleted) {
          userCount = contest.userCount;
          winnerCount = contest.winnerCount;
          updateRPTime = contest.updateRPTime
            ? moment(contest.updateRPTime).format("lll")
            : updateRPTime;
          updateSSUploadTime = contest.updateSSUploadTime
            ? moment(contest.updateSSUploadTime).format("lll")
            : updateSSUploadTime;
          updateWinningsTime = contest.updateWinningsTime
            ? moment(contest.updateWinningsTime).format("lll")
            : updateWinningsTime;
          status = contest.status ? contest.status : "Waiting";
          assignUser = contest?.assignUser;
          joinedCount = contest.totalJoinedPlayers;
          totalActualWinners = contest.totalActualWinners;
          matchDate = moment(contest.date).format("DD, MMM YYYY");
          matchTime = moment(contest.time).format("hh:mm A");
        }
      });
    }
    if (data.type === "assignUser") {
      return assignUser || "Not Updated";
    }
    if (data.type === "updateRPTime") {
      return updateRPTime;
    }
    if (data.type === "updateSSUploadTime") {
      return updateSSUploadTime;
    }
    if (data.type === "updateWinningsTime") {
      return updateWinningsTime;
    }
    if (data.type === "status") {
      return status;
    }
    if (data.type === "winnerCount") {
      return totalActualWinners + "/" + winnerCount;
    }
    if (data.type === "userCount") {
      return joinedCount + "/" + userCount;
    }
    if (data.type === "date") {
      return matchDate;
    }
    if (data.type === "time") {
      return matchTime;
    }
    return 1;
  };

  const contestViewItem = (mId) => {
    // let contestId;
    // constestData.forEach((data) => {
    //   if (data.code === mId && !data.isDeleted) {
    //     contestId = data._id;
    //   }
    // });
    // history.push(`/contests/view/${contestId}`);
    const url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/contests/view/${mId}`;
    window.open(url, "_blank");
  };
  const exportContestJoinUser = (mId) => {
    dispatch(actions.exportJoinedUserByContestId(mId));
    // let contestId;
    // constestData.forEach((data) => {
    //   if (data.code === mId && !data.isDeleted) {
    //     contestId = data._id;
    //   }
    // });
    // history.push(`/contests/view/${contestId}`);
    // const url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/contests/view/${mId}`;
    // window.open(url, "_blank");
  };
  useEffect(() => {
    // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>tournamentRounds", tournamentRounds);
    if (tournamentRounds?.rounds?.length > 0) {
      let tempRoundData = tournamentRounds?.rounds.map((e) => ({
        isSaved: e.isSaved,
        code: e.code.slice(0, -2),
        dates: e.dates.map((a) => new Date(a)),
        isFinalRound: e.isFinalRound,
        name: e.name,
        isSearched: false,
        timeSlotForSelectedDropdown: null,
        statusForSelectedDropdown: null,
        assignForSelectedDropdown: null,
        dateRange: null
      }));
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>tempRoundData", tempRoundData);
      setRoundData(tempRoundData);
    }
  }, [tournamentRounds]);

  // useEffect(() => {
  //   console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>roundsData",roundsData)
  // }, [roundsData]);
  const applyFilterMatch = (data, round) => {
    // console.log("tournamentForEdit.createdTime", tournamentForEdit.createdAt)
    if (round?.round?.dateRange === null) {
      NotificationManager.error("Please select date", "Error");
      return
    }
    let data1 = {}
    data1.search = {
      roundName: round?.round?.code,
      date: moment(round?.round?.dateRange).tz('Asia/Kolkata').format('YYYY-MM-DD'),
      timeSlot: round?.round?.timeSlotForSelectedDropdown?.value || "all",
      assignTo: round?.round?.assignForSelectedDropdown?.value || "all",
      status: round?.round?.statusForSelectedDropdown?.value || "all",
      createdAt: tournamentForEdit?.createdAt || null
    }
    dispatch(actions.fetchTournamentRoundMatches(id, data1)).then((result) => {
      if (result.success) {
        // console.log("RESPONSE>>>>>>>>>>fetchTournamentRoundMatches",result.contestsAry,round)
        updateContestData(result.contestsAry, round, 'Matches')
        setcontestData(result.contestsAry)
      }
    }).catch((e) => {
      // console.log(e)
      updateContestData([], round, 'Matches')
      setcontestData(null)
    })


  };
  const updateContestData = (value, rounds, type) => {
    // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>updateContestData",value,rounds,type,roundsData)
    let updatedRounds = roundsData.map((round) => {
      if (round.name === rounds.round.name) {
        if (type === 'Matches') {
          return { ...round, matches: value };
        }
      } else {
        return { ...round, matches: [] };
      }
      // return round;
    });
    setRoundData(updatedRounds);
    console.log("Updated Rounds:", updatedRounds);
  };

  const onDropDownChange = (value, rounds, type) => {
    console.log(type)
    console.log(value)
    let updatedRounds = roundsData.map((round) => {
      if (round.name === rounds.round.name) {
        if (type === 'TimeSlot') {
          return { ...round, timeSlotForSelectedDropdown: value };
        } else if (type === 'Status') {
          return { ...round, statusForSelectedDropdown: value };
        } else if (type === 'Assign') {
          return { ...round, assignForSelectedDropdown: value };
        } else if (type === 'DateRange') {
          // console.log("onDropDownChange>>>>DateRange", value)
          return { ...round, dateRange: value };
        }
      }
      return round;
    });
    setRoundData(updatedRounds);
    // console.log("Updated Rounds:", updatedRounds);
  };
  const GetMatchsByFilter = (round, key) => {
    console.log("ROUNDS::",key, round)
    return <div style={{ marginTop: '20px', width: '90%' }}><Formik key={key}
      initialValues={{ dateRang: dateRange }}
      onSubmit={(values) => { applyFilterMatch(values, round); }}>
      {({ handleSubmit, values }) => (
        <div className="">
          <form
            onSubmit={handleSubmit}
            className="form form-filter w-100"
            autoComplete="off"
          >
            <div className="form-group row m-0">
              <div className="col-3">
                {/* {console.log("{round.round.dates}",round.round.dates)} */}
                <DatePicker
                  className="form-control datepicker"
                  selected={round.round.dateRange ? new Date(round.round.dateRange) : null}
                  onSelect={(value) => console.log(value) || onDropDownChange(value, round, "DateRange")}
                  dateFormat="yyyy-MM-dd" // Format for displaying the date
                  isClearable
                  placeholderText="Select Date"
                  includeDates={selectDateRange || round.round.dates}
                />
              </div>
              <div className="col-2">
                <DropdownReactSelect
                  placeholder={"TimeSlot"}
                  name={"TimeSlot"}
                  value={round.round.timeSlotForSelectedDropdown || {label: 'All', value: "all"}}
                  isMulti={false}
                  isClearable={true}
                  isSearchable={true}
                  closeMenuOnSelect={true}
                  options={timeSlotForDropdown}
                  onChange={(value) => onDropDownChange(value, round, "TimeSlot")}
                />
              </div>

              <div className="col-3">
                <DropdownReactSelect
                  placeholder={"Status"}
                  name={"Status"}
                  value={round.round.statusForSelectedDropdown || {label: 'All', value: "all"}}
                  // isMulti={values.isShared == 'true' ? true : false}
                  isMulti={false}
                  isClearable={true}
                  isSearchable={true}
                  closeMenuOnSelect={true}
                  options={statusForDropdown}
                  onChange={(value) => onDropDownChange(value, round, "Status")}
                />
              </div>
              <div className="col-3">
                <DropdownReactSelect
                  placeholder={"Assign"}
                  name={"Assign"}
                  value={round.round.assignForSelectedDropdown || {label: 'All', value: "all"}}
                  // isMulti={values.isShared == 'true' ? true : false}
                  isMulti={false}
                  isClearable={true}
                  isSearchable={true}
                  closeMenuOnSelect={true}
                  options={staffUserList.length > 0 ? staffUserList.map((a) => { return { label: a.user.name, value: a.user._id } }) : [{label: 'All', value: "all"}]}
                  onChange={(value) => onDropDownChange(value, round, "Assign")}
                />
              </div>

              <div className="justify-content-end mx-2">
                <button
                  type="submit"
                  className="btn btn-dark"

                >
                  Search
                </button>
              </div>
            </div>
          </form>
          {/* </div> */}
        </div>
      )}
    </Formik></div>
  };
  return (
    <>
      {pointSummaryActionsLoading === true &&
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)", // semi-transparent white background
            zIndex: 9999, // ensure it's on top of other elements
          }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      }
      <NotificationContainer />
      {actionsLoading && <ModalProgressBar />}
      <div className="col-md-12">
        <GamerjiTournamentSummeryDetailsNew type={"view"} />
        {/* <GamerjiTournamentSummeryDetails type={"view"} /> */}

        {helperFunc.isButtonAccess("tournament.pointsummary.get") &&
          tournamentForEdit.winningTerm === "point base" && (
            <>
              <div className="row mb-5">
                {tournamentForEdit?.status === 'review' &&
                  <div className="col-xl-2 custom-class12 mb-3" style={{ maxWidth: "200px !important" }}>
                    <button
                      type="button"
                      onClick={() => viewPointSummary()}
                      className="btn btn-primary w-100"
                    >
                      Point Summary
                    </button>
                  </div>
                }
                {
                  tournamentForEdit?.status === 'completed' ?
                    tournamentForEdit?.summaryLink !== undefined ?
                      <div className="col-xl-2 custom-class12 mb-3" style={{ maxWidth: "200px !important" }}>
                        <button
                          type="button"
                          onClick={() => downloadPointSummary()}
                          className="btn btn-primary w-100"
                        >
                          Point Summary Download
                        </button>
                      </div>
                      :
                      <div className="col-xl-2 custom-class2 mb-3">
                        <ExportDataTableButton
                          loading={actionsLoading}
                          typeOfExportDataTable={["CSV"]}
                          exportButtonCSVAPICall={exportPointButtonCSVAPICall}
                          buttonName="Generate Point Summary"
                        />
                      </div>
                    : <></>

                }
              </div>

              {/* <div className="export-button-container" style={{ marginLeft: "1389px", marginTop: "-70px" }}>
           
              <button
              type="button"
              onClick={() => viewPointSummary1()}
              className="btn mt-20m btn-primary"
            >
              Point Summary export
            </button>
          
            </div> */}
            </>
          )}

        {helperFunc.isButtonAccess("tournament.ranksummary.get") &&
          tournamentForEdit.winningTerm === "rank" && (
            <>
              <div className="row mb-5">
                <div className="col-xl-2 custom-class12 mb-3">
                  <button
                    type="button"
                    onClick={() => viewRankSummary()}
                    className="btn btn-primary w-100"
                  >
                    Rank Summary
                  </button>
                </div>
                <div className="col-xl-2 custom-class2 mb-3">
                  <ExportDataTableButton
                    loading={actionsLoading}
                    typeOfExportDataTable={["CSV"]}
                    exportButtonCSVAPICall={exportButtonCSVAPICalll}
                    buttonName="Rank Summary Download"
                  />
                </div>
              </div>
            </>
          )}

        <Col className="mb-4 col-md-12">
          {roundsData &&
            roundsData &&
            roundsData.map((round, index) => (
              // console.log(round, '--------------------') ||
              <Card key={"round" + index} className="text-capitalize">
                <CardHeader title={round.name}>
                  {<GetMatchsByFilter round={round} key={round.name} />}
                </CardHeader>
                <CardBody>
                  {round?.matches?.length > 0 &&
                    <table className="table table-bordered table-striped font-12em">
                      <thead>
                        <tr>
                          <th>Sr No</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Assign To</th>
                          {/* <th>RP TIME </th>
                        <th>SS TIME </th>
                        <th>WD TIME </th> */}
                          <th>Status</th>
                          <th>Total User Count</th>
                          <th>Total Winners Count</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {round?.matches.map((match, ind) => (

                          <tr key={"match" + ind}>
                            <td>{ind + 1}</td>
                            <td>{moment(match.date).format("DD, MMM YYYY")}</td>
                            <td>{moment(match.time).format("hh:mm A")}</td>
                            <td>
                              {/* <ContestStatus
                                matchId={match.code}
                                type={"assignUser"}
                              /> */}
                              {match.assignUser}

                            </td>
                            <td>
                              {/* <ContestStatus
                                matchId={match.code}
                                type={"status"}
                              /> */}
                              {match.status}

                            </td>
                            <td>
                              {/* <ContestStatus
                                matchId={match.code}
                                type={"userCount"}
                              /> */}

                              {`${match.totalJoinedPlayers}/${match.userCount}`}
                            </td>
                            <td>
                              {/* <ContestStatus
                                matchId={match.code}
                                type={"winnerCount"}
                              /> */}
                              {`${match.totalActualWinners}/${match.winnerCount}`}
                            </td>
                            <td>
                              {helperFunc.isButtonAccess(
                                "tournament.closeTournaments.get"
                              ) && (
                                  <Link
                                    onClick={() => contestViewItem(match._id)}
                                    className="btn w-60px btn-sm btn-primary font-weight-bolder text-uppercase"
                                  >
                                    View
                                  </Link>
                                )}
                                {match?.companyCode ==='IG' && helperFunc.isButtonAccess(
                                "tournament.closeTournaments.export"
                              ) && (
                                  <Link
                                    onClick={() => exportContestJoinUser(match._id)}
                                    
                                    className="ml-2 btn w-80px btn-sm btn-primary font-weight-bolder text-uppercase"
                                  >
                                    Export
                                  </Link>
                                )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  }


                </CardBody>
              </Card>
            ))}
        </Col>
      </div>
    </>
  );
};
export default GamerjiTournamentView;
